



































import { SeamlessCoreStore } from '@seamless/store';
import VueSeamlessStore from '@seamless/vue-store-plugin';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

import { b2xlcComponentConfig } from './interfaces/types';
import { initializeComponentRegistry } from '@owc/component-registry-connection';

import { Logger, TENANT } from '@b2x/common';
import {
  AuthenticationDispatchers,
  AUTHENTICATION_CONNECTION,
  isLoggedIn,
  getIdentityProvider,
  getAlert,
  initializeUsingAEM,
  AuthDispatchersCias,
  AuthDispatchersBias,
  Alert,
  AuthenticationState,
  IdentityProvider,
  dispatchTracking,
  initializeAuthentication,
  Stages,
  isPending,
} from '@b2x/authentication-library';

@Component({
  mixins: [new VueSeamlessStore().mixin],
})
export default class App extends Vue {
  logger = new Logger('LOGIN_BUTTON');

  // https://pages.git.daimler.com/dh-io-mbmxp/seamless/#/guidelines/store/component-registry?id=component-registry
  @Prop({ type: String })
  componentId!: string;

  @Ref() readonly componentWrapper!: HTMLDivElement;

  componentRegistry!: any;

  store!: SeamlessCoreStore;

  authenticationDispatchers!: AuthenticationDispatchers;
  authenticationDispatchersCias!: AuthDispatchersCias;
  authenticationDispatchersBias!: AuthDispatchersBias;

  isLoggedIn = false;

  translations: Record<string, string> = {
    login: 'Login',
    logout: 'Logout',
  };

  alert: Alert | null = null;

  languageDirection = 'ltr';

  tenantId = location.hostname.includes('localhost') ? TENANT.CIAS : TENANT.ONEWEB;

  userMenu: Element | null = null;

  async created(): Promise<void> {
    this.logger.log('login component created', this.$props);

    if (window.top?.aemNamespace) {
      this.componentRegistry = initializeComponentRegistry();
      this.componentRegistry.subscribe(this.componentId, this.onComponentConfig);
    }

    // await initializeAuthentication({
    //   identityProvider: IdentityProvider.CIAS,
    //   tenantId: TENANT.CIAS,
    //   country: 'DE',
    //   language: 'de',
    //   stage: Stages.INT,
    // });

    initializeUsingAEM();

    this.authenticationDispatchers = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION);
    // this.authenticationDispatchersCias = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION_CIAS);
    // this.authenticationDispatchersBias = await this.store.getConnectionDispatchers(AUTHENTICATION_CONNECTION_BIAS);

    this.store.subscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
  }

  onLogin(event: MouseEvent): void {
    event.preventDefault();

    this.logger.log('onLogin called');

    dispatchTracking({
      type: 'LB',
      label: 'login',
    });

    this.authenticationDispatchers.login({ identityProvider: IdentityProvider.CIAS, tenantId: this.tenantId });
    // this.authenticationDispatchersCias.login({
    //   redirectUrl: 'http://localhost:8080/miro',
    // });
    // this.authenticationDispatchersBias.login();
  }

  onLogout(event: MouseEvent): void {
    event.preventDefault();

    this.logger.log('onLogout called');

    dispatchTracking({
      type: 'LB',
      label: 'logout',
    });

    this.authenticationDispatchers.logout();
    // this.authenticationDispatchersCias.logout({
    //   targetUrl: 'http://localhost:8080/miguel',
    // });
    // this.authenticationDispatchersBias.logout();
  }

  onAuthenticationEvent(state: AuthenticationState): void {
    if (isPending(state)) {
      return;
    }

    this.logger.log('New auth event, isLoggedIn', state);
    const issuer = getIdentityProvider(state);

    if (issuer === IdentityProvider.CIAS) {
      this.isLoggedIn = isLoggedIn(state);
    }

    this.handleAlert(getAlert(state));
  }

  handleAlert(alert: Alert | null): void {
    try {
      if (alert) {
        this.logger.error('Show alert', alert);

        if (this.tenantId === TENANT.ONEWEB) {
          this.triggerUserMenuVisibility();
        }
      }

      this.alert = alert;
    } catch (e) {
      this.logger.error('Failed to handle alert');
    }
  }

  triggerUserMenuVisibility(): void {
    this.logger.debug('calling triggerUserMenuVisibility');

    try {
      // eslint-disable-next-line
      // @ts-ignore
      const headerShadowRoot: ShadowRoot = this.componentWrapper.parentNode.host.parentNode.shadowRoot;
      const userMenuButtonSelector = 'owc-header-secondary-flyout[name=mme]';
      const userFlyout = headerShadowRoot.querySelector(userMenuButtonSelector);

      if (userFlyout) {
        this.userMenu = userFlyout;
        this.userMenu.setAttribute('open', 'true');
      } else {
        // eslint-disable-next-line no-undef
        const onMutation: MutationCallback = (mutations: MutationRecord[], observer: MutationObserver) => {
          for (const mutation of mutations) {
            if (mutation.type === 'childList') {
              const userMenuBtn = headerShadowRoot.querySelector(userMenuButtonSelector);

              if (userMenuBtn) {
                this.userMenu = userMenuBtn as HTMLElement;
                break;
              }
            }
          }

          setTimeout(() => {
            if (!this.userMenu?.getAttribute('open')) {
              this.userMenu?.setAttribute('open', 'true');
              this.logger.debug('triggered a click on user flyout menu');
            }
          }, 100);

          observer.disconnect();
        };

        const observer = new MutationObserver(onMutation);
        observer.observe(headerShadowRoot, { childList: true, subtree: true });
      }
    } catch (e) {
      this.logger.log('could not open user flyout menu', e);
    }
  }

  onAlertDismiss(): void {
    this.logger.debug('dismissing alert');
    try {
      this.authenticationDispatchers.removeAlert();

      if (this.userMenu?.getAttribute('open') === 'true') {
        this.logger.debug('menu is open, trying to close');
        this.userMenu.setAttribute('open', 'false');
      }
    } catch (e) {
      this.logger.error('could not dismiss alert');
    }
  }

  onComponentConfig(componentConfig: b2xlcComponentConfig): void {
    this.logger.log('component config', { componentConfig });

    if (componentConfig.payload) {
      this.translations.login = componentConfig.payload.login;
      this.translations.logout = componentConfig.payload.logout;
    }
  }

  beforeDestroy(): void {
    this.store.unsubscribe(this.componentId, this.onComponentConfig);
    this.store.unsubscribe(AUTHENTICATION_CONNECTION, this.onAuthenticationEvent);
  }
}
